import { IconSvg, IconSvgProps } from "./icon"

export default function Profile(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 12a4.179 4.179 0 1 0 0-8.357A4.179 4.179 0 0 0 12 12ZM19.946 20.357a8.345 8.345 0 0 0-15.892 0h15.892Z" />
    </IconSvg>
  )
}
